import { Shop } from 'models/Shop';
import {
  ResultItem,
  Description as ShopDescription,
  AiDisclaimer,
  DescriptionText
} from './ShopResultItem.styles';
import React from 'react';
import CardHeader from './CardHeader/CardHeader';
import ShopStatus from './ShopStatus/ShopStatus';
import {
  appendEmbedToExternalHref,
  validateExternalUrl
} from 'helpers/externalUrl';
import { useIntl } from 'react-intl';

const ShopResultItem = ({ shop, embed }: { shop: Shop; embed?: boolean }) => {
  const { formatMessage } = useIntl();
  const showRatingAndStars =
    !!shop.reviewCount && !!shop.averageRating && shop.reviewCount !== 0;
  const showCertificateState = typeof shop.certificationState !== 'undefined';
  /* istanbul ignore next */
  const shopUrl = appendEmbedToExternalHref(
    validateExternalUrl(shop.profileUrl || shop.shopUrl),
    embed
  );

  return (
    <ResultItem href={shopUrl} target="_blank" rel="follow">
      <CardHeader
        shop={shop}
        embed={embed}
        isSingleElement={
          /* istanbul ignore next */
          !shop.shopDescription && !showRatingAndStars && !showCertificateState
        }
      />
      {(showRatingAndStars || showCertificateState) && (
        <ShopStatus
          shop={shop}
          showRatingAndStars={showRatingAndStars}
          showCertificateState={showCertificateState}
        />
      )}
      {shop.shopDescription && (
        <ShopDescription>
          <DescriptionText>{shop.shopDescription}</DescriptionText>
          {shop.descriptionAutoGenerated && (
            <AiDisclaimer>
              {formatMessage({ id: 'AI_GENERATED_DESCRIPTION.BRIEFING' })}
            </AiDisclaimer>
          )}
        </ShopDescription>
      )}
    </ResultItem>
  );
};

export default ShopResultItem;
